import {computeSingleInputBoundaryIndex} from 'notebook/tables/store/logic/TableStructureLogic';
import {createTableModelSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore, TableEditableVolatileProps} from 'notebook/tables/store/TableStore';
import {TableIndex} from 'notebook/tables/TableConstants';

export interface TableStructureModel {
  /**
   * The column index of the first non-single-input column.
   * Returns null if there are no single input columns.
   */
  singleInputBoundaryIndex: number | null;

  /**
   * The first cell index of the table [0, 0].
   */
  firstIndex: TableIndex;

  /**
   * The last cell index of the table [numRows - 1, numCols - 1].
   */
  lastIndex: TableIndex;
}

export function createSingleInputBoundaryIndexSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => number | null {
  return createTableModelSelector([(store) => volatilePropsSelector(store).table], (table) =>
    computeSingleInputBoundaryIndex(table)
  );
}

function createLastIndexSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => TableIndex {
  return createTableModelSelector(
    [(store) => volatilePropsSelector(store).table],
    (table): TableIndex => [table.table.length - 1, table.table[0].length - 1]
  );
}

export function createTableStructureSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => TableStructureModel {
  return createTableModelSelector(
    [
      createSingleInputBoundaryIndexSelector(volatilePropsSelector),
      createLastIndexSelector(volatilePropsSelector),
    ],
    (singleInputBoundaryIndex, lastIndex) => ({
      singleInputBoundaryIndex,
      lastIndex,
      firstIndex: [0, 0],
    })
  );
}
